import { Component } from "react";
import { Container, Navbar, Nav } from "react-bootstrap";
import { Outlet } from "react-router-dom";
import { LogoutButton } from "./logoutBtn";

export class AppNavbar extends Component {
    render() {
        return (<>
            <Navbar bg="dark" data-bs-theme="dark">
                <Container>
                    <Navbar.Brand href="/formv2">Teach Insights</Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                        <Navbar.Collapse id="basic-navbar-nav">
                            <Nav className="me-auto">
                                <Nav.Link href="/formv2">Forms</Nav.Link>
                                <Nav.Link href="/admin">Admin</Nav.Link>
                                <Nav.Link href="/analytics">Analytics</Nav.Link>
                            </Nav>
                            <Nav>
                                <Nav.Link><LogoutButton /></Nav.Link>
                            </Nav>
                        </Navbar.Collapse>
                </Container>
            </Navbar>
            <Outlet />
        </>)
    }
}